<template>
  <div>
    <!-- banner -->
    <el-carousel style="width: 100%" height="759px" class="carousel" :autoplay="true" :interval="5000" arrow="hover">
      <el-carousel-item v-for="item in bannerList" :key="item.id">
        <img :src="item.picUrl" alt="" style="width: 100%; height: 100%">
      </el-carousel-item>
    </el-carousel>
    <!-- 下单浮窗 -->
    <div class="order_box" v-show="orderVisible">
      <div class="order_box_title">
        <img :src="require('@/assets/img/bus.png')" alt="">
        <span>物流查询 & 在线下单</span>
      </div>
      <div class="order_box_search">
        <div class="order_box_search_left">
          <el-input v-model.trim="searchValue" placeholder="输入运单号"  maxlength="100" clearable></el-input>
        </div>
        <div class="order_box_search_right" @click="searchClick">
          <img :src="require('@/assets/img/search_icon.png')" alt="">
          <span>查询</span>
        </div>
      </div>
      <div class="order_box_btn_list">
        <div class="order_box_btn_item" style="background-color: #3B71DB;" @click="skipOrder">
            <img :src="require('@/assets/img/search_icon3.png')" alt="">
            <span>在线下单</span>
          </div>
      </div>
    </div>
    <div class="order_box_state" @click="checkOrderState">
      <template v-if="!orderVisible">
        <div>物流</div>
        <div>查询</div>
      </template>
      <div v-else>关闭</div>
    </div>
    <!-- 服务产品 -->
    <div class="service_product">
      <div class="service_content">
        <div class="content_title scrollRevealLeft">
          <span class="content_title_zh">服务产品</span>
          <span class="content_title_en">/service products</span>
        </div>
        <div class="service_list">
          <div class="service_item scrollRevealBottom" v-for="(item, index) in serviceList" :key="index">
            <div class="service_item_default" :style="{ background: `url(${item.bg})` }">
              <div class="service_item_content">
                <div class="service_item_title"><span>{{ item.title }}</span></div>
                <div class="service_item_info"><span>{{ item.info }}</span></div>
                <div class="service_item_line"></div>
              </div>
            </div>
            <div class="service_item_checked" :style="{ background: `url(${item.activeBg})` }">
              <div class="service_item_checked_title">{{ item.title }}</div>
              <div class="service_item_content">
                <div class="service_item_info"><span>{{ item.info }}</span></div>
                <div class="service_item_line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 介绍产品 -->
    <div class="introduce">
      <div class="content_title scrollRevealLeft">
        <span class="content_title_zh" style="color: #333333;">京递快运</span>
        <span class="content_title_en" style="color: rgba(0, 0, 0, .64);">/JD logisticss</span>
      </div>
      <div class="introduce_content">
        <div class="introduce_top">
          <div class="introduce_top_left">
            <div class="introduce_item scrollRevealLeft">
              <img :src="require('@/assets/img/jieshao1.png')" alt="">
              <div class="introduce_item_text">
                <div class="introduce_item_title">京递飞快</div>
                <div class="introduce_item_info">
                  <div></div>
                  <span>发货网点200公里之内预约时间送达，门店</span>
                </div>
              </div>
            </div>
          </div>
          <div class="introduce_top_right">
            <div class="introduce_item scrollRevealRight">
              <img :src="require('@/assets/img/jieshao2.png')" alt="">
              <div class="introduce_item_text">
                <div class="introduce_item_title">京递好快</div>
                <div class="introduce_item_info">
                  <div></div>
                  <span>优先中转 车尾装置 专车派送 专属客服</span>
                </div>
              </div>
            </div>
            <div class="introduce_item scrollRevealBottom">
              <img :src="require('@/assets/img/jieshao3.png')" alt="">
              <div class="introduce_item_text">
                <div class="introduce_item_title">京递标快</div>
                <div class="introduce_item_info">
                  <div></div>
                  <span>大众运价 品质服务</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="introduce_mid">
          <div class="introduce_item scrollRevealBottom">
            <img :src="require('@/assets/img/jieshao4.png')" alt="">
            <div class="introduce_item_text">
              <div class="introduce_item_title">京递跨境</div>
              <div class="introduce_item_info">
                <div></div>
                <span>全国揽收 时效稳定 全程路由 专人服务</span>
              </div>
            </div>
          </div>
        </div>
        <div class="introduce_bottom">
          <div class="introduce_item scrollRevealBottom">
            <img :src="require('@/assets/img/jieshao5.png')" alt="">
            <div class="introduce_item_text">
              <div class="introduce_item_title">冷运快达</div>
              <div class="introduce_item_info">
                <div></div>
                <span>冷链运输 优先派送 专属服务</span>
              </div>
            </div>
          </div>
          <div class="introduce_item scrollRevealBottom">
            <img :src="require('@/assets/img/jieshao6.png')" alt="">
            <div class="introduce_item_text">
              <div class="introduce_item_title">整车直发</div>
              <div class="introduce_item_info">
                <div></div>
                <span>满足客户一辆或多辆用车的整车直达产品</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="about">
      <div class="content_title scrollRevealLeft">
        <span class="content_title_zh" style="color: #333333;">关于我们</span>
        <span class="content_title_en" style="color: rgba(0, 0, 0, .64);">/About Us</span>
      </div>
      <div class="about_box">
        <div class="about_box_left scrollRevealTop"></div>
        <div class="about_box_right scrollRevealBottom">
          <div class="about_box_title scrollRevealRight">
            <img :src="require('@/assets/img/about_title_icon.png')" alt="">
            <span>公司简介</span>
          </div>
          <div class="about_box_info scrollRevealRight">
            <span>京递
              是拥有十五年[互联网十物流]团队创办大货品类快运公司。在扎实的商流驱动物流的远景规划中，以互连互通数智化去拥抱电商市场进军大货快运赛道。以超强的互联网速度和过硬的IT技术，体验中国智造消费流通的便利，高度重视[客户体验]的基础上，顶层追求大货集运。以稳定十时效十温度，通过数字化整合国内网点，完成大货时效保障，踏实极致的塑造伙伴可信赖的供应商。</span>
          </div>
        </div>
      </div>
      <div class="about_list">
        <div class="about_item"
          style="background: linear-gradient( 137deg, rgba(255,255,255,0.86) 0%, #FFFFFF 80%, #E3E9FF 100%);">
          <img class="about_item_img scrollRevealLeft" :src="require('@/assets/img/about1.png')" alt="">
          <div class="about_item_content">
            <img class="about_item_icon" :src="require('@/assets/img/about_icon1.png')" alt="">
            <div class="about_item_text">
              <div class="about_item_title"><span>企业愿景</span></div>
              <div class="about_item_info"><span>致力成为客户最信赖合作商</span></div>
              <div class="about_item_line"></div>
            </div>
          </div>
        </div>
        <div class="about_item scrollRevealRight"
          style="background: linear-gradient( 137deg, rgba(255,255,255,0.86) 0%, #FFFFFF 80%, #FFECE5 100%);">
          <img class="about_item_img" :src="require('@/assets/img/about2.png')" alt="">
          <div class="about_item_content">
            <img class="about_item_icon" :src="require('@/assets/img/about_icon2.png')" alt="">
            <div class="about_item_text">
              <div class="about_item_title"><span>企业使命</span></div>
              <div class="about_item_info"><span>物畅其流 赋能客户成长</span></div>
              <div class="about_item_line"></div>
            </div>
          </div>
        </div>
        <div class="about_item scrollRevealTop"
          style="background: linear-gradient( 137deg, rgba(255,255,255,0.86) 0%, #FFFFFF 80%, #D4EEFF 100%);">
          <img class="about_item_img" :src="require('@/assets/img/about3.png')" alt="">
          <div class="about_item_content">
            <img class="about_item_icon" :src="require('@/assets/img/about_icon3.png')" alt="">
            <div class="about_item_text">
              <div class="about_item_title"><span>企业价值观</span></div>
              <div class="about_item_info"><span>以感恩的心态善待客户 ，以用户愉快体验为己任</span></div>
              <div class="about_item_line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom">
      <div class="bottom_left">
        <div class="bottom_input">
          <img :src="require('@/assets/search.png')" alt="" />
          <el-input v-model.trim="searchValue" placeholder="输入运单号" style="flex: 1;" maxlength="100"
            clearable></el-input>
        </div>
        <div class="search_button" @click="searchClick">查询</div>
        <div class="search_button" @click="orderListClick" style="margin-left:20px;width:200px;">转运公司查询</div>
      </div>
      <div class="bottom_right" @click="skipOrder">
        <img :src="require('@/assets/online.png')" alt="" />
        <span>在线下单</span>
      </div>
    </div> -->
    <el-dialog title="转运公司查询结果" :visible.sync="orderListVisible" top="1vh" width="1200px">
      <div>
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
          <el-form-item label="转运公司账号：" prop="phone">
            <el-input v-model="queryParams.phone" placeholder="请输入转运公司账号" clearable style="width: 240px" maxlength="50"
              @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="日期：" prop="createDate">
            <el-date-picker v-model="queryParams.createDate" type="date" value-format="yyyy-MM-dd" style="width: 240px"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
            <el-button type="primary" size="small" v-if="total > 0" @click="getExportExcl">表格导出</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="roleList" v-if="roleList.length > 0">
          <el-table-column label="序号" type="index" align="center" width="100" />
          <el-table-column label="订单创建信息" align="center">
            <el-table-column label="创建人" prop="createUserName" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="创建时间" prop="createTimeSpan" align="center" :show-overflow-tooltip="true"
              width="200" />
            <el-table-column label="运单编号" prop="orderNo" align="center" :show-overflow-tooltip="true" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row && scope.row.orderNo || '-' }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="寄件人信息" align="center">
            <el-table-column label="寄件人姓名" prop="senderName" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="寄件人手机号" prop="senderTel" align="center" :show-overflow-tooltip="true" width="150" />
            <el-table-column label="寄件人固话" prop="senderFixed" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="省市区" prop="senderCodeSPan" align="center" :show-overflow-tooltip="true"
              width="250"></el-table-column>
            <el-table-column label="详细地址" prop="senderAddress" align="center" :show-overflow-tooltip="true"
              width="200" />
            <el-table-column label="单位名称" prop="senderCompanyName" align="center" :show-overflow-tooltip="true"
              width="150" />
          </el-table-column>
          <el-table-column label="收件人信息" align="center">
            <el-table-column label="收件人名称" prop="receiverName" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="收件人手机号" prop="receiverTel" align="center" :show-overflow-tooltip="true"
              width="150" />
            <el-table-column label="收件人固话" prop="receiverFixed" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="省市区" prop="receiverCodeSPan" align="center" :show-overflow-tooltip="true"
              width="250" />
            <el-table-column label="详细地址" prop="receiverAddress" align="center" :show-overflow-tooltip="true"
              width="200" />
            <el-table-column label="单位名称" prop="receiverCompanyName" align="center" :show-overflow-tooltip="true"
              width="150" />
          </el-table-column>

          <el-table-column label="运输类型" prop="transportTypeSpan" align="center" width="100" />
          <el-table-column label="装车状态" prop="loadStatusSpan" align="center" :show-overflow-tooltip="true"
            width="150" />
          <el-table-column label="关联客户公司" prop="companyName" align="center" :show-overflow-tooltip="true" width="150" />
          <el-table-column label="关联客户姓名" prop="customerName" align="center" :show-overflow-tooltip="true"
            width="150" />
          <el-table-column label="关联客户电话" prop="customerTel" align="center" :show-overflow-tooltip="true" width="150" />
          <el-table-column label="订单信息" align="center">
            <el-table-column label="起始站" prop="originatingStationSpan" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="到达站" prop="arriveStationSpan" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="收货网点" prop="receivingPointSPan" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="分货网点" prop="distributionPointSPan" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="约定到达" prop="agreedArrivalSPan" align="center" :show-overflow-tooltip="true"
              width="100" />
          </el-table-column>
          <el-table-column label="物品信息" align="center">
            <el-table-column label="物品名称" prop="name" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="物品件数" prop="qty" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="实际重量(kg)" prop="weightRel" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="实际体积(方)" prop="volumeRel" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="包装" prop="packaging" align="center" :show-overflow-tooltip="true" width="100" />
          </el-table-column>
          <el-table-column label="配送信息" align="center">
            <el-table-column label="配送方式" prop="deliveryTypeSpan" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="等通知收货" prop="releaseCargoTypeSpan" align="center" :show-overflow-tooltip="true"
              width="100" />
          </el-table-column>
          <el-table-column label="费用信息" align="center">
            <el-table-column label="运费金额" prop="totalPriceRel" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="付款方式" prop="payTypeSpan" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="寄件人付款比例" prop="senderPayRate" align="center" :show-overflow-tooltip="true"
              width="200" />
            <el-table-column label="到付" prop="arriveAmount" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="现付" prop="cashAmount" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="欠付" prop="owedAmount" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="回单付" prop="hdfAmount" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="回单收条" prop="hdIdSpan" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="回单数" prop="hdCount" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="回扣" prop="rebate" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="现付回扣" prop="cashRebate" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="欠付回扣" prop="owedRebate" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="提货费" prop="deliveryCharge" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="送货费" prop="dropOffCharge" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="是否有代收货款" prop="isCollectedSpan" align="center" :show-overflow-tooltip="true"
              width="200" />
            <el-table-column label="代收金额" prop="amountCollected" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="代垫费" prop="advanceAmount" align="center" :show-overflow-tooltip="true"
              width="100" />
          </el-table-column>
          <el-table-column label="车辆信息" align="center">
            <el-table-column label="驾驶员姓名" prop="driverName" align="center" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="驾驶员电话" prop="driverTel" align="center" :show-overflow-tooltip="true" width="150" />
            <el-table-column label="车牌号" prop="licensePlateNumber" align="center" :show-overflow-tooltip="true"
              width="100" />
          </el-table-column>
          <el-table-column label="订单状态" align="center">
            <el-table-column label="回单状态" prop="hdReturnStatusSpan" align="center" :show-overflow-tooltip="true"
              width="100" />
            <el-table-column label="订单状态" prop="statusSpan" align="center" :show-overflow-tooltip="true" width="100" />
          </el-table-column>
          <el-table-column label="取件人/送件人信息" align="center">
            <el-table-column label="取件人姓名" prop="consignee" align="center" :show-overflow-tooltip="true" width="200" />
            <el-table-column label="取件人手机号" prop="consigneeTel" align="center" :show-overflow-tooltip="true"
              width="200" />
            <el-table-column label="取件地址" prop="pickUpAddress" align="center" :show-overflow-tooltip="true"
              width="200" />
            <el-table-column label="送件人姓名" prop="courier" align="center" :show-overflow-tooltip="true" width="200" />
            <el-table-column label="送件人手机号" prop="courierTel" align="center" :show-overflow-tooltip="true"
              width="200" />
          </el-table-column>
          <el-table-column label="备注信息" align="center">
            <el-table-column label="收货备注" prop="pickUpGoodsRemark" align="center" :show-overflow-tooltip="true"
              width="250" />
            <el-table-column label="分货备注" prop="subdivisionRemark" align="center" :show-overflow-tooltip="true"
              width="250" />
          </el-table-column>
        </el-table>
        <el-pagination v-if="roleList.length > 0" background layout="prev, pager, next" style="margin-top:20px;"
          :current-page="queryParams.pageNum" @current-change="setPage" :total="total">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="查询结果" :destroy-on-close="true" :visible.sync="searchVisible" top="1vh" width="800px">
      <div style="height:800px;overflow-y: scroll;">
        <div class="destination_order">单号：{{ orderDetail && orderDetail.orderNo }}</div>
        <div class="destination" v-if="orderDetail">
          <div class="destination_left">
            {{ orderDetail.sendCity }}
          </div>
          <img :src="require('@/assets/freight.png')" alt="" />
          <div class="destination_right">
            {{ orderDetail.receiverCity }}
          </div>
        </div>
        <el-timeline v-if="orderDetail">
          <el-timeline-item v-for="(activity, index) in orderDetail.details" :key="index">
            <div class="timeline_item">
              <div class="timeline_item_time">
                {{ activity.createTimeSpan }}
                <span style="margin-left: 10px">{{
                  activity.statusSpan
                }}</span>
              </div>
              <div class="timeline_item_content">
                {{ activity.content }}
                <div class="timeline_item_imgBox"
                  v-if="activity.status == 2 && activity.userInfo.picPathList.length > 0">
                  <el-image v-for="(key, keyIndex) in activity.userInfo.picPathList" :key="keyIndex" :src="key"
                    fit="cover" class="timeline_item_img" :preview-src-list="[key]">
                  </el-image>
                </div>
                <div class="timeline_item_imgBox"
                  v-if="activity.status == 6 && activity.userInfo.picPathList.length > 0">
                  <el-image v-for="(key, keyIndex) in activity.userInfo.picPathList" :key="keyIndex" :src="key"
                    fit="cover" class="timeline_item_img" :preview-src-list="[key]">
                  </el-image>
                </div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAreaSelect, getLoginPic, getTokenCheck, getInfo, search, banner, listTable } from "@/api/home";
import { setToken, getToken, removeToken, JsonDownload } from '@/utils/auth'
// import { JsonDownload } from '@/utils/downLoad'
import scrollReveal from "scrollreveal";
import Hedaers from '../hedaer/index.vue'
import banner1 from '@/assets/banner/banner1.png'
import banner2 from '@/assets/banner/banner2.png'
import banner3 from '@/assets/banner/banner3.png'
import serviceItemBg1 from '@/assets/img/service_bg1.png'
import serviceItemBg2 from '@/assets/img/service_bg2.png'
import serviceItemBg3 from '@/assets/img/service_bg3.png'
import serviceItemActiveBg1 from '@/assets/img/about_active1.png'
import serviceItemActiveBg2 from '@/assets/img/about_active2.png'
import serviceItemActiveBg3 from '@/assets/img/about_active3.png'
export default {
  metaInfo: {
    title: '京递快运官网 - 首页', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '京递快运官网 - 首页'
    },
    {
      name: 'description',
      content: '京递 是拥有十五年[互联网十物流]团队创办大货品类快运公司。在扎实的商流驱动物流的远景规划中，以互连互通数智化去拥抱电商市场进军大货快运赛道。以超强的互联网速度和过硬的IT技术，体验中国智造消费流通的便利，高度重视[客户体验]的基础上，顶层追求大货集运。以稳定十时效十温度，通过数字化整合国内网点，完成大货时效保障，踏实极致的塑造伙伴可信赖的供应商。'
    }
    ],
  },
  name: "home",
  components: { Hedaers },
  data() {
    return {
      searchValue: null,
      searchVisible: false,
      orderDetail: null,
      bannerList: [
        {
          picUrl: banner1
        },
        {
          picUrl: banner2
        },
        {
          picUrl: banner3
        }
        // {
        //     picUrl:require('@/assets/banner1.png')
        // },
        // {
        //     picUrl:require('@/assets/banner2.png')
        // }
      ],
      orderListVisible: false,
      roleList: [],
      total: 0,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        createDate: ""
      },
      dateRange: [],
      serviceList: [
        {
          bg: serviceItemBg1,
          activeBg: serviceItemActiveBg1,
          title: '标准达',
          info: '及时配送到客户仓库'
        },
        {
          bg: serviceItemBg2,
          activeBg: serviceItemActiveBg2,
          title: '预约达',
          info: '按照客户需求派送'
        },
        {
          bg: serviceItemBg3,
          activeBg: serviceItemActiveBg3,
          title: '夜班达',
          info: '晚上预约合理派送'
        }
      ],
      scrollReveal: scrollReveal(),
      orderVisible:false
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.dialogVisible;
      },
      set() {
        this.cancelDataScope();
      },
    },
  },
  created() {

    // this.gerBanner();
  },
  mounted() {
    this.setScrollReveal();
  },
  methods: {
    skipOrder() {
      this.$router.push({
        path: '/order'
      })
    },
    gerBanner() {
      banner({ dataType: 1, status: 1 }).then(response => {
        if (response.code == 200) {
          this.bannerList = response.data;
        }
      })
    },
    searchClick() {
      if(!getToken()) return this.$message.warning('请登录后再进行查询运单操作');
      if (!this.searchValue) return this.$message.warning('请输入运单编号进行查询');
      search({}, this.searchValue).then(response => {
        if (response.code == 200) {
          this.orderDetail = response.data;
          this.searchVisible = true;
        }
      })
    },
    orderListClick() {
      this.orderListVisible = true;
    },
    // 查询
    handleQuery() {
      // if (this.dateRange) {
      //     this.queryParams.startTime = this.dateRange[0];
      //     this.queryParams.endTime = this.dateRange[1];
      // } else {
      //     this.queryParams.startTime = null;
      //     this.queryParams.endTime = null;
      // }
      if (!this.queryParams.phone) return this.$message.warning('请输入转运公司账号');
      // if(!this.queryParams.createDate) return this.$message.warning('请选择日期');
      this.queryParams.pageNum = 1;
      this.getList();
    },
    setPage(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    getList() {
      this.loading = true;
      if (!this.queryParams.createDate) {
        this.queryParams.createDate = ""
      }
      if (!this.queryParams.phone) {
        this.queryParams.phone = ""
      }
      listTable(this.queryParams).then(response => {
        this.roleList = response.rows;
        this.total = response.total;
        if (this.total == 0) this.$message.warning('暂未查询到相关数据');
        this.loading = false;
      }
      );
    },
    getExportExcl() {
      if (!this.queryParams.createDate) {
        this.queryParams.createDate = ""
      }
      JsonDownload(`/Expressage/pc/export?createDate=${this.queryParams.createDate}&phone=${this.queryParams.phone}`, {
        ...this.queryParams
      }, `转运公司查询运单_${new Date().getTime()}.xlsx`, 'get')
    },
    setScrollReveal() {
      this.scrollReveal.reveal(".scrollRevealBottom", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "bottom",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "300px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealLeft", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "left",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "200px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealRight", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "right",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "200px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealTop", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "top",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "300px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
    },
    checkOrderState(){
      this.orderVisible = !this.orderVisible;
    }
  },
};
</script>
<style>
/* .order_box_search .el-input__inner {
  border-color: transparent !important;
  background: transparent !important;
  font-size: 20px;
  color: #333;
} */
</style>
<style lang="scss" scoped>
.order_box_state{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 14px;
  color: #fff;
  background: #FF8A00;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1000;
  position: fixed;
  right: 0px;
  top: 500px;
  cursor: pointer;
  user-select: none;
}
.order_box {
  width: 637px;
  height: 587px;
  background: url('../../assets/img/order_bg.png') no-repeat;
  background-size: cover;
  position: fixed;
  right: 315px;
  top: 210px;
  z-index: 100;
  box-sizing: border-box;
  padding: 46px 38px 0 38px;

  .order_box_title {
    display: flex;
    align-items: center;
    font-size: 26px;
    color: #fff;
    font-weight: 600;
    margin-bottom: 187px;
    cursor: pointer;
    img {
      width: 34px;
      height: 34px;
      margin-right: 10px;
    }
  }
  .order_box_search{
    width: 561px;
    height: 80px;
    border-radius: 8px;
    background: #fff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 15px;
    margin-bottom: 104px;
    ::v-deep .el-input__inner {
      border-color: transparent !important;
      background: transparent !important;
      font-size: 20px;
      color: #333;
    }
    .order_box_search_left{
      flex: 1;
    }
    .order_box_search_right{
      width: 117px;
      height: 50px;
      border-radius: 8px;
      background: #FF8A00;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 600;
      color: #fff;
      margin-left: 20px;
      user-select: none;
      img{
        width: 22px;
        height: 22px;
        margin-right: 8px;
      }
    }
  }
  .order_box_btn_item{
      width: 100%;
      height: 73px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
      img{
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  .order_box_btn_row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .order_box_btn_item{
      width: 265px;
    }
  }
}

.carousel {

  // height: 100vh;
  ::v-deep .el-carousel__arrow {
    width: 50px;
    height: 50px;
    font-size: 20px;
    background: rgba($color: #000000, $alpha: .5);
    border: 2px solid #fff;
    box-sizing: border-box;
  }

  ::v-deep .el-carousel__indicators--horizontal {
    left: 22%;
    bottom: 3%;
  }
}

.content_title {
  position: relative;
  color: #fff;
  margin: 0 auto;
  margin-bottom: 80px;
  width: 1291px;

  &::before {
    content: '';
    width: 78px;
    height: 13px;
    border-radius: 7px;
    background: #FF8A00;
    position: absolute;
    left: 0;
    bottom: 3px;
    z-index: 1;
  }

  .content_title_zh {
    font-size: 48px;
    font-weight: 500;
    position: relative;
    z-index: 2;
  }

  .content_title_en {
    color: rgba($color: #fff, $alpha: .64);
    font-size: 24px;
    font-weight: 400;
    padding-left: 20px;
  }
}

.bottom {
  width: 1400px;
  height: 154px;
  margin: 0 auto;
  margin-top: -77px;
  padding: 40px;
  border-radius: 14px;
  box-sizing: border-box;
  background: #295091;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 10;

  .bottom_left {
    display: flex;
    align-items: center;

    .bottom_input {
      width: 638px;
      height: 70px;
      display: flex;
      align-items: center;
      background: #fff;
      box-sizing: border-box;
      padding: 10px 20px;
      font-size: 24px;
      color: #333;
      border-radius: 3px;
      margin-right: 20px;

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }

      div {
        width: 100px;
      }

      .el-input__inner {
        border: 1px solid transparent !important;
      }
    }

    .search_button {
      width: 177px;
      height: 70px;
      line-height: 70px;
      border-radius: 6px;
      color: #fff;
      background: #7EA8FD;
      font-size: 24px;
      text-align: center;
      cursor: pointer;
    }
  }

  .bottom_right {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 24px;
    cursor: pointer;

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
}

.el-carousel__item {
  width: 100%;
  height: 100%;
}

.el-carousel__item img {
  width: 100%;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.destination {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333;
  margin-bottom: 40px;

  img {
    width: 30px;
    height: 30px;
    margin: 0 10px;
  }
}

.timeline_item {
  // display: flex;
  // align-items: center;
  font-size: 16px;
  color: #333;

  .timeline_item_time {
    width: 300px;
    margin-right: 40px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #ccc;
  }

  .timeline_item_content {
    font-size: 14px;
    color: #333;
  }
}

.el-timeline {
  padding-left: 0;
}

.timeline_item_imgBox {
  color: #295091;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}

.timeline_item_img {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  margin-right: 10px;
  margin-bottom: 10px;
}

.destination_order {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}

// 服务产品
.service_product {
  width: 100%;
  height: 933px;
  background: url('../../assets/img/product_bg.png') no-repeat;
  background-size: cover;
  margin-bottom: 80px;

  .service_content {
    width: 1291px;
    margin: 0 auto;
    padding-top: 227px;
  }

  .service_list {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .service_item {
      width: 410px;
      height: 479px;
      position: relative;
      cursor: pointer;

      // overflow: hidden;
      .service_item_default {
        width: 100%;
        height: 100%;
        position: relative;
        background-repeat: no-repeat;
        overflow: hidden;

        .service_item_content {
          padding-top: 280px;
          padding-left: 34px;

          .service_item_title {
            font-size: 26px;
            color: #000;
            font-weight: 600;
            margin-bottom: 11px;
          }

          .service_item_info {
            font-size: 16px;
            font-weight: 400;
            color: #333;
            margin-bottom: 23px;
          }

          .service_item_line {
            width: 36px;
            height: 5px;
            background: #FF8A00;
          }
        }

      }

      .service_item_checked {
        position: absolute;
        left: 0;
        top: 0;
        width: 410px;
        height: 100%;
        // background: rgba($color: #000000, $alpha: .3);
        transform: translate(-410px);
        opacity: 0;
        z-index: 3;
        transition: all .4s;
        pointer-events: none;

        .service_item_checked_title {
          position: absolute;
          left: -18px;
          bottom: 132px;
          width: 171px;
          height: 54px;
          background: linear-gradient(180deg, #FFBE00 0%, #FF8A00 100%);
          border-radius: 0px 100px 100px 0px;
          color: #fff;
          font-size: 26px;
          text-align: center;
          line-height: 54px;
          font-weight: 600;
        }

        .service_item_content {
          padding-top: 358px;
          padding-left: 34px;

          .service_item_info {
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            margin-bottom: 23px;
          }

          .service_item_line {
            width: 36px;
            height: 5px;
            background: #FF8A00;
          }
        }
      }
    }

    .service_item:hover .service_item_checked {
      transform: translate(0px);
      opacity: 1;
    }
  }
}

// 介绍产品
.introduce {
  width: 1291px;
  margin: 0 auto;
  margin-bottom: 97px;

  .introduce_item {
    border-radius: 19px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    color: #fff;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      transition: all .3s;
    }

    .introduce_item_text {
      position: relative;
      z-index: 2;
      padding-left: 32px;
    }
  }

  .introduce_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;

    .introduce_top_left {
      width: 630px;
      height: 444px;

      .introduce_item {
        width: 100%;
        height: 100%;

        .introduce_item_text {
          padding-top: 345px;
        }
      }
    }

    .introduce_top_right {
      width: 630px;

      .introduce_item {
        width: 100%;
        height: 207px;
        position: relative;
        margin-bottom: 30px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          transition: all .3s;
        }

        .introduce_item_text {
          position: relative;
          z-index: 2;
          padding-left: 32px;
          padding-top: 116px;
        }

        &:last-child {
          margin-bottom: 0;

        }
      }
    }
  }

  .introduce_mid {
    width: 100%;
    height: 232px;
    margin-bottom: 30px;

    .introduce_item {
      width: 100%;
      height: 232px;

      .introduce_item_text {
        padding-top: 140px;
      }
    }
  }

  .introduce_bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .introduce_item {
      width: 630px;
      height: 400px;

      .introduce_item_text {
        padding-top: 301px;
      }
    }
  }

  .introduce_item:hover {
    img {
      transition: all .3s;
      transform: scale(1.1);
    }
  }

  .introduce_item_title {
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .introduce_item_info {
    display: flex;
    font-size: 16px;
    align-items: center;

    div {
      width: 8px;
      height: 8px;
      background: #FF8A00;
      margin-right: 7px;
    }
  }
}

// 关于我们
.about {
  .about_box {
    width: 1920px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 77px;

    .about_box_left {
      background: url('../../assets/img/about_img.png') no-repeat;
      background-size: cover;
      width: 1053px;
      height: 688px;
      flex-shrink: 0;
    }

    .about_box_right {
      background: url('../../assets/img/about_bg.png') no-repeat;
      background-size: cover;
      box-sizing: border-box;
      width: 1126px;
      height: 373px;
      flex-shrink: 0;
      position: relative;
      left: -259px;
      top: 65px;
      padding-top: 30px;
      padding-left: 100px;

      .about_box_title {
        width: 270px;
        height: 88px;
        background: url('../../assets/img/about_title.png') no-repeat;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 30px;
        font-weight: 500;
        margin-bottom: 30px;

        img {
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }
      }

      .about_box_info {
        width: 750px;
        font-size: 18px;
        color: #fff;
        font-weight: 500;
        line-height: 34px;
      }
    }
  }

  .about_list {
    width: 1291px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 60px;

    .about_item {
      width: 410px;
      height: 459px;
      box-shadow: 0px 2px 60px 0px rgba(0, 0, 0, 0.04);
      border-radius: 100px 0px 100px 0px;
      box-sizing: border-box;
      padding: 20px;

      .about_item_img {
        width: 370px;
        height: 238px;
        margin-bottom: 47px;
      }

      .about_item_content {
        display: flex;

        .about_item_icon {
          width: 73px;
          height: 73px;
          margin-right: 24px;
        }

        .about_item_text {
          flex: 1;
          color: #000;

          .about_item_title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 7px;
          }

          .about_item_info {
            font-size: 18px;
            font-weight: 400;
            margin-bottom: 18px;
          }

          .about_item_line {
            width: 35px;
            height: 5px;
            background: #FF8A00;
          }
        }
      }
    }
  }
}
</style>